module.exports = __webpack_public_path__ + "static/hydra-hero.ee7435ab.svg";